import {useQuery} from "@tanstack/react-query";
import {PaymentService} from "../services/payment-service";

export const usePaymentStatus = () => {
    const queryInfo = useQuery({
        queryKey: ['payment', 'status'],
        queryFn: async () => await PaymentService.status(),
    });

    return {
        ...queryInfo,
        get paymentStatus() { return queryInfo.data; },
    };
};
